import { CustomState } from "@SupplyLand/Store/Components/CategoryProduct/CategoryProductReducer";

export function getCategoryProducts(state: CustomState, categoryId: string) {
    return state.categoryProductData.categoryIdToChildProducts[categoryId];
}
